module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-group-detail--layout"
  }, [_vm._l((_vm.medicineSet), function(med, num) {
    return _c('div', {
      staticClass: "single-med"
    }, [_c('span', [_vm._v(_vm._s(med.generic_name))]), _c('div', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.deleteDrugFromGroup(num)
        }
      }
    }, [_vm._v("x")])])
  }), _c('hr'), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrugToGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-dynamic",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addDrugToGroup
    }
  }, [_vm._v("新增")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMedicines.length !== 0),
      expression: "searchMedicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.searchMedicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name))])
  }), 0)])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇藥物")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b829de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/DrugGroupDetail.vue
// module id = 1417
// module chunks = 1